import React from "react";
import { Chip } from "@mui/material";

interface CourseStatusChipProps {
  status?: string;
  size?: "small" | "medium";
}

function CourseStatusChip({ status = "draft", size = "small" }: CourseStatusChipProps): React.JSX.Element {
  const normalizedStatus = (status || "").toLowerCase();

  const color =
    normalizedStatus === "published"
      ? "success"
      : normalizedStatus === "draft"
      ? "warning"
      : normalizedStatus === "archived"
      ? "error"
      : "default";

  return <Chip label={status} color={color as any} size={size} />;
}

export default CourseStatusChip;